import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { pathPickQueryApi } from "@/features/pathpick/api/query";
import { PathPickAutocompleteSuggestion } from "@/features/pathpick/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 검색창 자동완성 — 부르는 쪽이 디바운스한 검색어를 넘긴다. 빈 검색어는 요청하지 않는다.
// brandIds 는 SKU 제안을 좁힐 브랜드 — 목록에 걸린 브랜드 필터 등(다른 브랜드 SKU 를 골라 0건이 되지 않게).
// 글자를 칠 때마다 목록이 비었다 차지 않도록 이전 결과를 유지한다(placeholderData).
// 같은 검색어는 1분간 다시 묻지 않는다 — 지웠다 다시 치는 흔한 동작에 요청이 안 나간다.
const useGetPathPickAutocomplete = (query: string, brandIds?: number[]) => {
  const { companyId } = useCompanyIdentity();
  const enabled = Boolean(companyId) && query.length > 0;
  // 순서가 달라도 같은 필터라 키를 정렬해 캐시를 공유한다.
  const brandKey = brandIds?.length ? [...brandIds].sort((a, b) => a - b) : [];

  const { data, isFetching } = useQuery({
    queryKey: ["pathpick", "autocomplete", companyId, query, brandKey],
    queryFn: () =>
      pathPickQueryApi.getPathPickAutocomplete(
        companyId as number,
        query,
        brandKey
      ),
    enabled,
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
    select: (items) =>
      items.map(
        (item) => toCamelKeyObject(item) as PathPickAutocompleteSuggestion
      ),
  });

  return {
    suggestions: enabled ? data ?? [] : [],
    isFetching,
  };
};

export default useGetPathPickAutocomplete;
